'use client';

import { useLocation } from '@reach/router';
import { type FC, useEffect } from 'react';

import t from '@/i18n/current';
import { requestIdleCallback } from '@/utils/request-idle-callback';

declare global {
    interface Window {
        bus: {
            on(name: string, callback: () => void): void;
            off(name: string, callback: () => void): void;
        };
    }
}

const busCallback = (): void => {
    console.dir(`impression_hash: ${window.impression_hash}`);
};

// TODO: Wydzielić generowanie tego skryptu oraz sw.js do osobnego modułu
const loadFiizyScripts = async (): Promise<void> => {
    window.app = window.app || { config: t.formApp.config };

    try {
        await import('@fiizy/fanalytics');
        const { eventbus, eventBusEvents } = await import('@fiizy/utils');

        const { newDeepLink } = eventBusEvents;
        window.bus = window.bus || eventbus(window.eventChannel || 'c432556660722ff93cefb5a932e550b7');

        window.bus.off(newDeepLink, busCallback);
        window.bus.on(newDeepLink, busCallback);
    } catch (error) {
        console.error(error);
    }
};

export const FiizyAnalyticsScript: FC = () => {
    const location = useLocation();

    useEffect(() => {
        if (window.app?.config) {
            loadFiizyScripts();

            return;
        }

        requestIdleCallback(loadFiizyScripts, 0);
    }, [location]);

    return null;
};
